document.addEventListener('DOMContentLoaded', function () {
  const searchInputs = document.querySelectorAll(
    '.header-item--search .search__input, .site-header__search .search__input'
  );

  if (!searchInputs.length) return;

  const phrases = [
    'Search products',
    'Search perfumes...',
    'Find your perfect fragrance...',
    'Explore men’s grooming...',
    'Discover skincare...',
    'Shop your favourites...'
  ];

  const typingSpeed = 80;
  const deletingSpeed = 45;
  const pauseAfterTyping = 1600;
  const pauseAfterDeleting = 400;

  searchInputs.forEach(function (input) {
    if (input.dataset.redifynTyping === 'true') return;

    input.dataset.redifynTyping = 'true';

    let phraseIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timer = null;

    function setPlaceholder(text) {
      input.setAttribute('placeholder', text);
    }

    function typeLoop() {
      // Don't animate while the customer is actively using the field
      if (document.activeElement === input || input.value.trim() !== '') {
        timer = null;
        return;
      }

      const phrase = phrases[phraseIndex];

      if (!deleting) {
        charIndex++;

        setPlaceholder(phrase.substring(0, charIndex));

        if (charIndex >= phrase.length) {
          timer = setTimeout(function () {
            deleting = true;
            typeLoop();
          }, pauseAfterTyping);
        } else {
          timer = setTimeout(typeLoop, typingSpeed);
        }
      } else {
        charIndex--;

        setPlaceholder(phrase.substring(0, charIndex));

        if (charIndex <= 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % phrases.length;

          timer = setTimeout(typeLoop, pauseAfterDeleting);
        } else {
          timer = setTimeout(typeLoop, deletingSpeed);
        }
      }
    }

    function stopAnimation() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      input.classList.remove('redifyn-search-active');
    }

    function startAnimation() {
      stopAnimation();

      // Don't animate when user already entered something
      if (input.value.trim() !== '') return;

      charIndex = 0;
      deleting = false;

      setPlaceholder('');

      input.classList.add('redifyn-search-active');

      timer = setTimeout(typeLoop, 350);
    }

    input.addEventListener('focus', function () {
      stopAnimation();

      if (input.value.trim() === '') {
        setPlaceholder('');
      }
    });

    input.addEventListener('blur', function () {
      if (input.value.trim() === '') {
        startAnimation();
      }
    });

    input.addEventListener('input', function () {
      stopAnimation();

      if (input.value.trim() === '') {
        startAnimation();
      }
    });

    // Start automatically
    startAnimation();
  });
});